import { useTranslation } from 'react-i18next';

import useCrossSurveyBenchmarkDataQuery from 'src/components/dashboard/hooks/useCrossSurveyBenchmarkDataQuery';

const useCrossSurveyBenchmarkData = (
  dashboardId?: number,
  filters: Record<string, string[]> = {},
  isEnabled = false,
) => {
  const { t } = useTranslation('common');
  const { data, isFetching, isLoading, error, refetch } =
    useCrossSurveyBenchmarkDataQuery(isEnabled, dashboardId, filters);
  const loading = isFetching || isLoading;

  const errorMsg =
    error === 'somethingWentWrong' ? t('somethingWentWrong') : error || '';

  return {
    data,
    loading,
    errorMsg,
    refetch,
  };
};
export default useCrossSurveyBenchmarkData;
